var _path, _path2, _path3, _path4, _path5;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgTdSymbol(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 46,
    height: 24,
    viewBox: "0 0 46 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M29.0398 23.413L17.7778 12.213L29.0398 1.01299L31.7118 3.699L23.1528 12.211L31.7118 20.722L29.0398 23.413Z",
    fill: "#08ADAC"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M34.6842 23.413L32.0122 20.726L40.5712 12.215L32.0122 3.70299L34.6842 1.01601L45.9472 12.216L34.6842 23.413Z",
    fill: "#08ADAC"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M11.262 23.394L0 12.194L11.262 0.993988L13.934 3.681L5.371 12.192L13.936 20.7L11.262 23.394Z",
    fill: "white"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M16.9059 23.394L14.2339 20.707L22.7929 12.196L14.2339 3.68399L16.9059 0.997009L28.1679 12.197L16.9059 23.394Z",
    fill: "white"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M20.4564 9.5376L17.7852 12.224L29.0377 23.4131L31.7089 20.7267L20.4564 9.5376Z",
    fill: "#08ADAC"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgTdSymbol);
export default __webpack_public_path__ + "static/media/td-symbol.452d80d2.svg";
export { ForwardRef as ReactComponent };